import { useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Popover, Box, Typography, Button } from '@mui/material';
import CustomTextInput from '../Forms/CustomTextInput';
import { updateCategory } from '../../redux/actions/inventory/inventory';
import { getMenusV2 } from '../../redux/actions/Menu/menuV2';

const CategoryEditPopover = ({ open, anchorEl, onClose, category, onSave }) => {
  const dispatch = useDispatch();
  const methods = useForm({
    defaultValues: {
      name: category?.name || '',
    },
  });

  useEffect(() => {
    if (category) {
      methods.reset({
        name: category.name || '',
      });
    }
  }, [category, methods]);

  const handleSave = async (data) => {
    try {
      if (category?._id) {
        await dispatch(
          updateCategory(category._id, {
            name: data.name.trim(),
          })
        );
        // Refresh menu data after successful save
        await dispatch(getMenusV2(false));
        // Refresh the list
        if (onSave) {
          onSave();
        }
      }
      onClose();
    } catch (error) {
      console.error('Error updating category:', error);
    }
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          sx: {
            width: 376,
            p: 3,
            position: 'relative',
          },
        },
      }}
    >
      {/* <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton> */}
      <FormProvider {...methods}>
        <Box component="form" onSubmit={methods.handleSubmit(handleSave)}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ width: 208 }}>
              <CustomTextInput name="name" label="Name *" fullWidth />
            </Box>

            <Box>
              <Typography
                sx={{ fontSize: 16, fontWeight: 400 }}
                color="text.secondary"
              >
                Items {category?.itemsCount || 0}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 4 }}
          >
            <Button variant="outlined" onClick={onClose} sx={{ width: '100%' }}>
              CANCEL
            </Button>
            <Button variant="contained" type="submit" sx={{ width: '100%' }}>
              SAVE
            </Button>
          </Box>
        </Box>
      </FormProvider>
    </Popover>
  );
};

export default CategoryEditPopover;
